import { deleteField, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export const removeFromCart = async (userId: string, productId: string) => {
  console.log("Product ID to remove:", productId); // Check the value of productId
  if (!productId) {
    console.error("Invalid productId");
    return;
  }

  const cartDocRef = doc(db, "cart", userId);
  try {
    await updateDoc(cartDocRef, {
      [productId]: deleteField(), // Remove the product from cart
    });
  } catch (error) {
    console.error("Error removing from cart:", error);
    throw error;
  }
};
